import React, { useState } from "react";
import { StrokedText } from "@/components/ui/text/stroked-text";
import { isXsScreen } from "@/utils/screen-size-check";
import { RaidIntroScene } from "./raid-intro-scene";
import classNames from "classnames";

interface RaidIntroViewProps {
  raidName: string;
  onComplete: () => void;
}

export const RaidIntroView: React.FC<RaidIntroViewProps> = ({
  raidName,
  onComplete,
}) => {
  const [overlayText, setOverlayText] = useState<{
    title?: string;
    subtitle?: string;
  } | null>(null);

  return (
    <div className="absolute inset-0 z-[99999] bg-black overflow-hidden">
      {/* PixiJS Scene Layer */}
      <div className="absolute inset-0">
        <RaidIntroScene
          raidName={raidName}
          onComplete={onComplete}
          setOverlayText={setOverlayText}
        />
      </div>

      {/* Overlay Text Layer */}
      <div
        className={classNames(
          "absolute inset-0 flex flex-col items-center justify-center pointer-events-none transition-opacity duration-500",
          {
            "opacity-0": !overlayText,
            "opacity-100": !!overlayText,
          },
        )}
      >
        {overlayText?.title && (
          <div className="mb-4">
            <StrokedText
              fontSize={isXsScreen() ? 20 : 24}
              strokeWidth={12}
              strokeColor="#232020"
              fillColor="#f4eae7"
              className="drop-shadow-xl"
            >
              {overlayText.title}
            </StrokedText>
          </div>
        )}
        {overlayText?.subtitle && (
          <div>
            <StrokedText
              fontSize={isXsScreen() ? 16 : 20}
              strokeWidth={8}
              strokeColor="#232020"
              fillColor="#fbbf24"
              className="drop-shadow-lg"
            >
              {overlayText.subtitle}
            </StrokedText>
          </div>
        )}
      </div>
    </div>
  );
};
